// extracted by css-extract-rspack-plugin
export default {"root":"SG0N1DwH8mrMwrzX","arrow":"c_d66U8XcgYboDrh","content":"lEJgmvSp6CE48U83"};